export default __webpack_public_path__ + "static/media/SearchL.390df58d.svg";